import { TabContent } from "./tab-content";
import { TabLink } from "./tab-link";
import { Tabs } from "./tabs";
export * from "./tabs";
export * from "./tab-content";
export * from "./tab-link";
export var TABS_DIRECTIVES = [
    TabContent,
    TabLink,
    Tabs
];
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/clarity-angular/layout/tabs/index.js
// module id = 194
// module chunks = 4